export enum EMyFeedbackConstant {
  DEFAULT_RECEIVER_DISPLAY_NUMBER = 2
}
